module.exports = __webpack_public_path__ + "media/images/emblems/Sommeri-Blazono-5952b0ee24b7090966d33bdbf915188a.png";